import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { api } from "../../api";
import { EMovementType, EVindiPaymentStatus } from "./enum/Enum";
import {
  ECategoryType,
  ESubcategoryType,
} from "../../interfaces/Products/IProductDetail";

export interface IFinancial {
  id: number;
  product: {
    category: ECategoryType;
    subcategory: ESubcategoryType;
    title: string;
  };
  movement_type: EMovementType;
  movement_type_text: string;
  payment_type: string;
  vindi_payment_status: EVindiPaymentStatus;
  vindi_payment_status_text: string;
  vindi_transaction_gateway_message: string;
  debit_amount: number;
  debit_transaction_at: string;
}

export interface IQueryFinancial {
  page: number;
  pageSize: number;
  sortOrder?: string;
  orderBy?: string;
  productName?: string;
}
export interface IResponseFinancial {
  data: IFinancial[];
  totalElements: number;
  totalPages: number;
}

const getFinancial = async ({
  page,
  pageSize,
  sortOrder,
  orderBy,
  productName,
}: IQueryFinancial): Promise<IResponseFinancial> => {
  let params = new URLSearchParams();
  if (!!page) params.append("page", page.toString());
  if (!!pageSize) params.append("pageSize", pageSize.toString());
  if (!!sortOrder) params.append("sortOrder", sortOrder);
  if (!!orderBy) params.append("orderBy", orderBy);
  if (!!productName) params.append("productName", productName);
  const { data } = await api.get<IResponseFinancial>("/web/user/finance", {
    params,
  });

  return data;
};

export const useFinancial = ({
  page,
  pageSize,
  sortOrder,
  orderBy,
  productName,
}: IQueryFinancial): UseQueryResult<IResponseFinancial> => {
  return useQuery(
    ["Financial", page, pageSize, sortOrder, orderBy, productName],
    () => getFinancial({ page, pageSize, sortOrder, orderBy, productName }),
    { enabled: !!page && !!pageSize, keepPreviousData: true }
  );
};
